import "core-js/modules/es.array.iterator.js";
export const average = array => {
  if (array.length === 0) return 0;
  return array.reduce((a, b) => a + b, 0) / array.length;
};
export const toRange = data => {
  const {
    value,
    from,
    to
  } = data;
  const [oldMin, oldMax] = from;
  const [newMin, newMax] = to;
  return (value - oldMin) * (newMax - newMin) / (oldMax - oldMin) + newMin;
};
export const animationFrame = (fn, opt) => {
  const {
    fps = 30
  } = opt !== null && opt !== void 0 ? opt : {};
  let now;
  let then = Date.now();
  const interval = 1000 / fps;
  let delta;
  const draw = () => {
    requestAnimationFrame(draw);
    now = Date.now();
    delta = now - then;
    if (delta > interval) {
      then = now - delta % interval;
      fn();
    }
  };
  draw();
};